import {Injectable} from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ApplicationService,
  ParcelAppEntityApplicationRead,
  ParcelAppEntityParcelRead,
  ParcelAppEntityParcelWrite,
  ParcelService
} from '../openapi';
import {forkJoin, Observable, of, switchMap} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParcelsCommonService {
  constructor(
    private parcelService: ParcelService,
    private applicationService: ApplicationService,
  ) {
  }

  public updateParcels(
    currentApp: ApplicationAppEntityApplicationRead,
    parcels: ParcelAppEntityParcelWrite[]
  ): Observable<ApplicationAppEntityApplicationRead> {
    if (parcels.length) {
      const oldIds: string[] = currentApp.parcels?.map((p: ParcelAppEntityApplicationRead) => p?.uuid || '') || [];
      const deleteRequest: Observable<any> = oldIds?.length ? forkJoin(oldIds.map(id => this.parcelService.deleteParcelParcelItem({id}))) : of([]);
      return deleteRequest.pipe(
        switchMap(() => {
          return forkJoin(
            parcels.map(parcel =>
              this.parcelService.postParcelParcelCollection({
                parcel
              })
            )
          ).pipe(
            switchMap((p: ParcelAppEntityParcelRead[]) =>
              this.applicationService.patchApplicationApplicationItem({
                id: currentApp?.uuid || '',
                application: { parcels: p.map(v => v?.uuid || '')}
              })
            )
          );
        })
      );
    } else {
      return this.applicationService.getApplicationItemApplicationItem({
        id: currentApp?.uuid || ''
      });
    }
  }
}
